module.exports = __webpack_public_path__ + "assets/img/elem6-ability1.7f844ee0.gif";